import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/star-scandal', label: t('nav.starScandal') },
    { to: '/category/influencer-downfall', label: t('nav.influencer') },
    { to: '/category/leaked-chats', label: t('nav.leakedChats') },
    { to: '/category/contrast-video', label: t('nav.contrastVideo') },
    { to: '/about', label: t('nav.about') },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(255,255,255,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
          >
            <span className="text-xl md:text-2xl font-black text-primary-400 tracking-tight">
              🔥91吃瓜
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-foreground-50/5'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-200 hover:text-foreground-50 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-800/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-foreground-50/5'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}